import RandingStyle1 from "../../randing/RandingStyle1";
// import { Helmet } from "react-helmet";

function Randing025({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <RandingStyle1
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        totalStep="2"
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/002/01_241101_01.jpg`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/025/01_241101_02.gif`}
        img3Path={`${process.env.REACT_APP_CDN_BASE}/images/025/01_241101_02.gif`} // 스텝 변경되는 이미지
        numberColor="#0824a4"
        qOptionColor="blue"
        keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/002/01_241101_03.png`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/002/02_241101_01.jpg`}
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/dlatl.jpg`}
      />
    </>
  );
}

export default Randing025;
